import Parse from 'parse';

export var client = new Parse.LiveQueryClient({
    applicationId: 'qd38MDMw9L37yUVcliBemAjSW6YosSXzNeOMH6C6',
    serverURL: 'wss://' + 'aid.back4app.io', // Example: 'wss://livequerytutorial.back4app.io'
    javascriptKey: 'SijHUPTfvwXJsCYWHGW86TTDUdi3qmYyxlWsvnUm',
    masterKey: 'iBBGDwYLo2v3t8W10uvavVMldAVNSZVmimZyqc14'
  });
  